/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userCoupons.internal

import features.userCoupons.models.UserCouponsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class UserCouponsRequest : NetworkRequest() {

    suspend fun getUserCoupons(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<UserCouponsModel> {
        return safeNetworkCall {
            get(
                endpoint = UserCouponsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
